// extracted by mini-css-extract-plugin
export var wave = "footerWave-module--wave--cde72";